"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineChartSVG = void 0;

var _d3Interpolate = require("d3-interpolate");

var _d3Shape = require("d3-shape");

var _react = _interopRequireDefault(require("react"));

var _renderprops = require("react-spring/renderprops.cjs");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Line = require("./Line");

var _Point = require("./Point");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Component rendering the SVG part of the line chart (e.g line and points)
 */
var LineChartSVG = function LineChartSVG(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      points = _ref.points,
      hoverIndex = _ref.hoverIndex,
      hasEnteredViewport = _ref.hasEnteredViewport;
  var values = points.map(function (d) {
    return d.value;
  });
  var maxValue = Math.max.apply(Math, _toConsumableArray(points.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })));
  var zeros = values.map(function () {
    return 0;
  });
  var valuesInterpolator = (0, _d3Interpolate.interpolateArray)(zeros, values);
  var w = width - 2 * margin;
  var h = height - 2 * margin; // maps value to x/y position

  var displayYPosition = function displayYPosition(d) {
    return maxValue ? h - d * h / maxValue : h;
  };

  var displayXPosition = function displayXPosition(_d, i) {
    return i / (points.length - 1) * w;
  };

  var line = (0, _d3Shape.line)().x(displayXPosition).y(displayYPosition);
  return _react.default.createElement(Svg, {
    width: width,
    height: height
  }, _react.default.createElement("g", {
    transform: "translate(0, ".concat(margin, ")")
  }, _react.default.createElement("line", {
    stroke: (0, _helpers.color)("black10"),
    x1: "0",
    x2: width,
    y1: h,
    y2: h
  }), _react.default.createElement("g", {
    transform: "translate(".concat(margin, ", 0)")
  }, _react.default.createElement(_renderprops.Spring, {
    from: {
      num: 0
    },
    to: hasEnteredViewport ? {
      num: 1
    } : {
      num: 0
    },
    delay: 500
  }, function (_ref3) {
    var num = _ref3.num;
    var interpolatedValues = valuesInterpolator(num);
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Line.Line, {
      path: line(interpolatedValues)
    }), interpolatedValues.map(function (value, index) {
      return _react.default.createElement(_Point.Point, {
        hovered: hoverIndex === index,
        key: index,
        opacity: num,
        cx: displayXPosition(value, index),
        cy: displayYPosition(value)
      });
    }));
  }))));
};

exports.LineChartSVG = LineChartSVG;
LineChartSVG.displayName = "LineChartSVG";

var Svg = _styledComponents.default.svg.withConfig({
  displayName: "LineChartSVG__Svg",
  componentId: "sc-1gkypr8-0"
})(["position:absolute;"]);
//# sourceMappingURL=LineChartSVG.js.map